/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import {
    object, shape, string, arrayOf, number, bool,
}  from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import GraphqlApplePay from '../../../GraphqlCommonComponents/GraphqlApplePay';
import { getFlags, getNoOfOrderItems, getPassportSubscriptionStatus } from '../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';

const useStyles = makeStyles(() => ({
    oneClickContainer: {
        width: '100%',
    },
}));
const OneClickPaymentBuilder = ({
    flags, selectedSku, numOrderItems, movieSelected, passportInCart, hasWine,
}) => {
    const classes = useStyles();
    return (
        <Grid container direction="column" className={classes.oneClickContainer}>
            {(typeof window !== 'undefined' && window.ApplePaySession && flags['is-apple-pay-enabled-pdp'] === true && selectedSku.ageVerifyFlag === 'false' && !hasWine && !passportInCart && !movieSelected && numOrderItems === 0)
                ? (
                    <Grid item container direction="column">
                        <Grid item><GraphqlApplePay selectedSku={selectedSku} /></Grid>
                    </Grid>
                ) : null}
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    flags: getFlags(state),
    numOrderItems: getNoOfOrderItems(state),
    passportInCart: getPassportSubscriptionStatus(state),
});

OneClickPaymentBuilder.propTypes = {
    flags: object.isRequired,
    hasWine: bool,
    selectedSku: shape({
        __typename: string.isRequired,
        id: string.isRequired,
        name: string.isRequired,
        ageVerifyFlag: string.isRequired,
        minAge: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
    }).isRequired,
    numOrderItems: number.isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    passportInCart: bool.isRequired,
};

OneClickPaymentBuilder.defaultProps = {
    movieSelected: null,
    hasWine: false,
};

export default connect(mapStateToProps, null)(OneClickPaymentBuilder);
